import { React, theme, pr } from "aaa";

const RadioButtonCircle = ({ selected }: { selected: boolean }) => (
    <div style={{ position: "relative", width: 20, height: 20 }}>
        {selected &&
            <span
                className="theme-radio-inner-color"
                style={{
                    height: 20,
                    width: 20,
                    borderRadius: "50%",
                    borderStyle: "solid",
                    borderWidth: 4,
                    position: "absolute",
                    left: 0,
                    boxSizing: "border-box"
                }}
            />
        }
        <span
            className={`theme-radio-color${selected ? " selected" : ""}`}
            style={{
                height: 20,
                width: 20,
                borderRadius: "50%",
                border: "2px solid",
                position: "absolute",
                left: 0,
                boxSizing: "border-box"
            }}
        />
    </div>
);

type IOption<Value> = {
    value: Value;
    label: string;
};

type IProps<Value> = {
    value: Value;
    name: string;
    options: IOption<Value>[];
    onChange: (value: Value, option?: IOption<Value>) => void;
    radioButtonStyle?: React.CSSProperties;
    labelStyle?: React.CSSProperties;
    disabled?: boolean;
    showDivider?: boolean;
};

export const RadioButtonGroup = <Value extends string | number,>({ options, value, name, onChange, radioButtonStyle, labelStyle, disabled, showDivider }: IProps<Value>) => {
    const handleChange = (event: any) => {
        onChange(event.target.value, options.find(option => option.value === event.target.value));
    };

    return (
        <>
            {options.map((option, index) => (
                <React.Fragment key={option.value}>
                    <div
                        className="theme-paragraph-color"
                        style={{ fontSize: 14, margin: theme.MARGIN, ...radioButtonStyle }}
                    >
                        <label
                            style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                gap: 13,
                                cursor: "pointer",
                                color: disabled ? theme.customColors.georgeLightGrey : undefined,
                                ...labelStyle
                            }}
                        >
                            <div>
                                <input
                                    type="radio"
                                    id={String(option.value)}
                                    name={name}
                                    value={option.value}
                                    onChange={handleChange}
                                    style={{ opacity: 0, display: "none" }}
                                    disabled={disabled}
                                    checked={option.value === value}
                                />
                                <RadioButtonCircle selected={option.value === value} />
                            </div>
                            <div>
                                {option.label}
                            </div>
                        </label>
                    </div>
                    {showDivider && index < options.length - 1 && <pr.LightSeparatorLine />}
                </React.Fragment>
            ))}
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/common/RadioButtonGroup.tsx